import type { ColorThemeId } from 'types/settings';

import type { ColorMode } from 'toolkit/chakra/color-mode';

export interface ColorTheme {
  id: ColorThemeId;
  label: string;
  colorMode: ColorMode;
  hex: string;
  sampleBg: string;
}

export const COLOR_THEMES: Array<ColorTheme> = [
  {
    id: 'light',
    label: 'روشن صبانفت',
    colorMode: 'light',
    hex: '#F7FAFD',
    sampleBg: 'linear-gradient(145deg, #EAF3FB 0%, #FFFFFF 58%, #FFF1DF 100%)',
  },
];
